import _ from 'underscore';

export default class UserProductSpecGroups {
  constructor($scope, UserProductService) {
    function init_group() {
      $scope.group = {
        title: ''
      };
    }

    function load_groups() {
      $scope.loading_groups = true;
      UserProductService.get_spec_groups(window.user_id).success(function(data) {
        if (data.success) {
          $scope.groups = data.groups;
          $scope.loading_groups = false;
        }
      });
    }

    function load_user_products() {
      UserProductService.get_user_products_without_groups(window.user_id).success(function(data) {
        $scope.user_products = data.user_products;
      });
    }

    $scope.create_group = function() {
      if ($scope.group.title.length === 0)
        return false;
      $scope.creating_group = true;
      UserProductService.create_spec_group(window.user_id, $scope.group.title).then(function(data) {
        if (data.success) {
          $scope.creating_group = false;
          init_group();
          load_groups();
        }
      });
    };

    $scope.add_product_to_group = function(group, user_product) {
      if (!user_product) {
        alert('Please select a user product!');
      } else {
        group.adding_product = true;
        UserProductService.add_user_product_to_spec_group(window.user_id, group.id, user_product.id).then(function(data) {
          if (data.success) {
            group.add_product = null;
            group.adding_product = false;
            load_groups();
            load_user_products();
          }
        });
      }
    };

    $scope.delete_product_from_group = function(group, user_product) {
      UserProductService.delete_user_product_from_spec_group(window.user_id, group.id, user_product.id).then(function(data) {
        if (data.success) {
          load_groups();
          load_user_products();
        }
      });
    };

    $scope.show_group_specs = function(group) {
      $scope.$broadcast('open_group_specs_dialog', {
        group_id: group.id
      });
    };

    $scope.sync_group_specs = function(group) {
      group.syncing_specs = true;
      UserProductService.sync_spec_group(group.id).then(function(data) {
        if (data.success)
          group.syncing_specs = false;
      });
    };

    $scope.get_group_user_products = function(group) {
      var group_product_ids = [];
      if (group.product_group_id) {
        group_product_ids = _.pluck(group.products, 'id');
        return _.filter($scope.user_products, function(p) {
          return p.product_group_id == group.product_group_id && !_.contains(group_product_ids, p.id);
        });
      } else {
        var mixed_groups = _.where($scope.groups, {
          product_group_id: null
        });
        _.each(mixed_groups, function(g) {
          group_product_ids = _.union(group_product_ids, _.pluck(g.products, 'id'));
        });
        return _.filter($scope.user_products, function(p) {
          return !_.contains(group_product_ids, p.id);
        });
      }
    };

    $scope.init = function() {
      $scope.groups = [];
      $scope.user_products = [];
      init_group();
      load_groups();
      load_user_products();
    };

    $scope.init();
  }
}

UserProductSpecGroups.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-spec-groups.ctrl.js